import { Input } from "antd";
export type { TextAreaProps } from "antd/lib/input";
const { TextArea } = Input;
export default TextArea;
